
        var result = require("!!../../../../node_modules/css-loader/index.js!./ramastanfooter.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/ramastanfooter/ramastanfooter.component.css
// module id = 56
// module chunks = 4